import type { DiagramLabelPosition, DiagramNode, DiagramLink } from './Diagram.types';
import { DiagramLabel } from './DiagramLabel';
import type { TextDimensions } from '../hooks/PRIVATE_useTextDimensions';
import { layerStyles } from './themes/DiagramStyles.css';
import { useUser } from '../hooks/UNSAFE_useUser';

type Props<K1, K2> = {
  labelPosition: (DiagramLabelPosition | undefined)[];
  itemProps: (DiagramNode<K1> | DiagramLink<K2, K1>)[];
  labelDimensions: Map<K1 | K2, TextDimensions>;
};

export function DiagramLabelLayer<K1, K2>({
  labelPosition,
  itemProps,
  labelDimensions
}: Props<K1, K2>) {
  const { direction } = useUser();
  return (
    <div class={layerStyles}>
      {itemProps.map((item, i) => {
        if (item.label && labelPosition[i]) {
          return (
            <DiagramLabel
              styles={item.labelStyle}
              text={item.label}
              position={labelPosition[i]!}
              dimensions={labelDimensions.get(item.id)!}
              isRTL={direction === 'rtl'}
            />
          );
        }
        return undefined;
      })}
    </div>
  );
}
